import { RICH_RESULT_TYPES } from "@stadium/constants";

export const FaqStructure = (data = []) => {
  const mainEntity = data?.map(({ question, answer }) => ({
    "@type": "Question",
    name: question,
    acceptedAnswer: {
      "@type": "Answer",
      text: answer,
    },
  }));

  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity,
  };
};

export const BreadcrumbStructure = (data = [], url = "https://www.snackmagic.com/") => {
  const breadcrumbList = data?.map(({ customTitle, route }, index) => ({
    "@type": "ListItem",
    position: index + 1,
    item: {
      "@id": `${url}${route}`,
      name: customTitle,
    },
  }));
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: breadcrumbList,
  };
};

export const AppendRichResult = (resultType = "", data = [], options = {}) => {
  const script = document.createElement("script");
  let jsonld = null;
  script.id = resultType;
  script.type = "application/ld+json";
  script.async = options.async != undefined ? options.async : true;
  script.defer = options.defer != undefined ? options.defer : true;
  script.setAttribute("data-ot-ignore", "");

  switch (resultType) {
    case RICH_RESULT_TYPES.FAQ:
      jsonld = FaqStructure(data);
      break;
    case RICH_RESULT_TYPES.BREAD_CRUMB:
      jsonld = BreadcrumbStructure(data);
      break;
    default:
      return "";
  }

  script.innerHTML = JSON.stringify(jsonld);
  let prevScript = document.getElementById(resultType);
  if (prevScript) {
    document.head.removeChild(prevScript);
  }
  return document.head.appendChild(script);
};
